import React from 'react';
import SalonDetail from '@features/salon-profile/SalonDetail';

const SalonDetailPage: React.FC = () => {
  return <SalonDetail />;
};

export default SalonDetailPage;
